import { render } from "./ThankYou.vue?vue&type=template&id=23c67f62&scoped=true"
const script = {}

import "./ThankYou.vue?vue&type=style&index=0&id=23c67f62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c67f62"]])

export default __exports__